// Doc lists 6 values (none·minimal·low·medium·high·xhigh); the numeric sibling enum is missing `xhigh`.
export default Object.freeze({
  None: 'none',
  Minimal: 'minimal',
  Low: 'low',
  Medium: 'medium',
  High: 'high',
  XHigh: 'xhigh',
});
